<template>
  <div>
    <div class="main">
      <div class="banner">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg8 xl8>
              <emb-home-main-banner :bannersList="BannerSection.Main_Banner_List"></emb-home-main-banner>
            </v-flex>
            <v-flex xs12 sm12 md12 lg4 xl4>
              <v-layout row wrap text-center mx-0>
                <v-flex xs12 sm6 md6 lg12 xl12 px-0>
                  <emb-aside-banner-v1 :sidebanner1="AsideBanner1"></emb-aside-banner-v1>
                </v-flex>
                <v-flex xs12 sm6 md6 lg12 xl12 px-0>
                  <emb-aside-banner-v2 :sidebanner2="AsideBanner2"></emb-aside-banner-v2>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <emb-features :data="ServiceSection"></emb-features>
      <emb-feature-product
        :secTitle="LabelSection.Featured_Products_Title"
        :data="featureProduct"
        :cat="categoryList"
      ></emb-feature-product>
      <emb-day-deal :data="dealDay" :dealsection="DealSection"></emb-day-deal>
      <emb-detail-offer :offer="SalesImageSection"></emb-detail-offer>
      <emb-feature-product
        :secTitle="LabelSection.New_Arrivals_Title"
        :data="newArrialProduct"
        :cat="categoryList"
      ></emb-feature-product>
      <embTestimonial :secTitle="LabelSection.Customer_Reviews_Title" v-if="reviewSection && reviewSection.length" :data="reviewSection "></embTestimonial>
      <emb-blog :secTitle="LabelSection.Latest_From_Blogs_Title" v-if="blogData && blogData.length" :data="blogData" ></emb-blog>
      <emb-subscribe :data="SubscribeSection"></emb-subscribe>
      <!-- <emb-shop-card secTitle="Shop By Brands" :data="shopCard"></emb-shop-card> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// layout components
import HomeMainBanner from "Components/Layouts/Banner/HomeMainBanner";
import AsideBannerV1 from "Components/Layouts/Banner/AsideBannerV1";
import AsideBannerV2 from "Components/Layouts/Banner/AsideBannerV2";

// widgets
import Features from "Components/Widgets/Feature";
import FeatureProduct from "Components/Widgets/FeatureProduct";
import DayDeal from "Components/Widgets/DayDeal";
import DetailOffer from "Components/Widgets/DetailOffer";
import Testimonial from "Components/Widgets/Testimonial";
import Blog from "Components/Widgets/Blog";
// import ShopCard from "Components/Widgets/ShopCard";
import Subscribe from "Components/Widgets/Subscribe";

// data
import gettingRestClientObject from "../../services/utils/cms-helper";
// import homeBannerData from "Assets/data/homeBannerData";
// import featuresData from "Assets/data/featuresData";
// import featureProductData from "Assets/data/featureProductData";
// import dayDealData from "Assets/data/dayDealData";
// import latestArrivalData from "Assets/data/latestArrivalData";
// import TestimonialData from "Assets/data/TestimonialData";
// import shopCard from "Assets/data/shopCard";
// import api from "Api";

export default {
  components: {
    embHomeMainBanner: HomeMainBanner,
    embAsideBannerV1: AsideBannerV1,
    embAsideBannerV2: AsideBannerV2,
    embFeatures: Features,
    embFeatureProduct: FeatureProduct,
    embDayDeal: DayDeal,
    embDetailOffer: DetailOffer,
    embTestimonial: Testimonial,
    embBlog: Blog,
    embSubscribe: Subscribe,
    // embShopCard: ShopCard
  },
  data() {
    return {
      // homeBannerData,
      // featuresData,
      // featureProductData,
      // dayDealData,
      // latestArrivalData,
      reviewSection: [],
      // shopCard,
      blogData: [],
      categoryList: {},
      BannerSection: {},
      AsideBanner1: {},
      AsideBanner2: {},
      ServiceSection: {},
      DealSection: {},
      SalesImageSection: {},
      LabelSection: {},
      SubscribeSection: {},
    };
  },
  created() {
    this.cmsRequestFunctions = gettingRestClientObject();
    // this.$store.dispatch("getProducts");
    this.getHomepageData();
    this.getBlogData();
    //this.readCustReview();
    this.getCategory();
    if (sessionStorage.validationItems == undefined) {
      this.cmsRequestFunctions.getValidationMsgs();
    }
  },
  computed: {
    ...mapGetters(["products", "selectedLocale"]),
    newArrialProduct() {
      return this.products.filter(
        (el) => el.Is_Active == true && el.Is_New_Arrival == true
      );
    },
    featureProduct() {
      return this.products.filter(
        (el) => el.Is_Active == true && el.Is_Feature == true
      );
    },
    dealDay() {
      return this.products.filter(
        (el) => el.Is_Active == true && el.Is_Limited_Time == true
      );
    },
  },
  watch: {
    selectedLocale: function () {
      // this.$store.dispatch("getProducts");
      this.getCategory();
      this.getHomepageData();
      this.getBlogData();
      //this.readCustReview();
      this.cmsRequestFunctions.getValidationMsgs();
    },
  },
  methods: {
    getHomepageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "18 Home Page/18 Home Page/18 Home Page.ftl",
        lang: language,
        successCallback: function (response) {
          // console.log(response);
          var res = response.data;
          if (res.area_List) {
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner__Section",
              res.area_List
            );
            self.BannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );

            var bannerArea1 = self.cmsRequestFunctions.pluck(
              "Side_banner_1",
              res.area_List
            );
            self.AsideBanner1 = self.cmsRequestFunctions.getAllMapData(
              bannerArea1[0].component
            );

            var bannerArea2 = self.cmsRequestFunctions.pluck(
              "Side_Banner_2",
              res.area_List
            );
            self.AsideBanner2 = self.cmsRequestFunctions.getAllMapData(
              bannerArea2[0].component
            );
            var customerReview = self.cmsRequestFunctions.pluck(
              "Customer_Reviews",
              res.area_List
            );
            var review = self.cmsRequestFunctions.getAllMapData(
              customerReview[0].component
            );
            self.reviewSection = review.Customer_List;
            var Main = self.cmsRequestFunctions.pluck(
              "Service_Section",
              res.area_List
            );
            self.ServiceSection = self.cmsRequestFunctions.getAllMapData(
              Main[0].component
            );

            var dealArea = self.cmsRequestFunctions.pluck(
              "Day_Deal__Data_Section",
              res.area_List
            );
            self.DealSection = self.cmsRequestFunctions.getAllMapData(
              dealArea[0].component
            );

            var ImageArea = self.cmsRequestFunctions.pluck(
              "Sales_Image_Section",
              res.area_List
            );
            self.SalesImageSection = self.cmsRequestFunctions.getAllMapData(
              ImageArea[0].component
            );

            var labelArea = self.cmsRequestFunctions.pluck(
              "Labels_Section",
              res.area_List
            );
            self.LabelSection = self.cmsRequestFunctions.getAllMapData(
              labelArea[0].component
            );

            var SubscribeArea = self.cmsRequestFunctions.pluck(
              "Subscribe_Section",
              res.area_List
            );
            self.SubscribeSection = self.cmsRequestFunctions.getAllMapData(
              SubscribeArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
    getBlogData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Master Table/",
        pageUrl: "Blog List/Blog List/Blog List.ftl",
        lang: language,
        successCallback: function (response) {
          self.blogData = [];
          var blogList = response.data;
          var blogListTemp = [];

          if (blogList != undefined && blogList.Values != undefined) {
            blogListTemp = blogList.Values.filter(function (el) {
              return el.Is_Active;
            });
            self.blogData = blogListTemp;
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getCategory: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "24 Configuration/24 Configuration/24 Configuration.ftl",
        lang: language,

        successCallback: function (response) {
          // console.log(response);
          var res = response.data;
          if (res.area_List) {
            var categoryArea = self.cmsRequestFunctions.pluck(
              "Category",
              res.area_List
            );
            var categoryListTemp = self.cmsRequestFunctions.getAllMapData(
              categoryArea[0].component
            );
            if (categoryListTemp.Category_List) {
              self.categoryList = categoryListTemp.Category_List;
            }
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>

